<script setup lang="ts">
import UiKitMain from "@/components/ui-kit/UiKitMain.vue";
import { computed, ref } from "vue";
import { allBrands, BRANDS_CONFIG, TypeBrand } from "@/config/brands";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import UiKitIcon from "@/components/ui-kit/UiKitIcon.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import UiKitBrands from "@/components/ui-kit/UiKitBrands.vue";

const route = useRoute();
const router = useRouter();

const tabsBrands = ref<TypeBrand[]>(allBrands);
const testSelectBrands = ref<TypeBrand>("atom");

const toggleTabsBrands = (item: TypeBrand) => {
  testSelectBrands.value = item;
};
const typeQuery = computed(() => route.query.type);
const testConfigDataBrand = computed(
  () => BRANDS_CONFIG[testSelectBrands.value]
);
</script>

<template>
  <div class="ui-kit-view" :data-theme="testSelectBrands">
    <router-link v-if="typeQuery" to="/ui-kit">
      <BaseFigureForIcon
        icon="arrow"
        position="left"
        is-button
        class="ui-kit-view__prev"
      />
    </router-link>
    <div v-else class="ui-kit-view__links">
      <p>Links:</p>
      <router-link class="ui-kit-view__links-item" to="?type=icon">
        Icons and Colors
      </router-link>
      <router-link class="ui-kit-view__links-item" to="?type=brands-config">
        BrandsConfig
      </router-link>
    </div>
    <div class="ui-kit-view__branding">
      <div class="ui-kit-view__branding-tabs">
        <div
          v-for="(item, index) in tabsBrands"
          :key="index"
          class="ui-kit-view__branding-tabs__item"
          :class="{ '--active': testSelectBrands == item }"
          @click="toggleTabsBrands(item)"
        >
          <p class="caption-navbar">
            {{ item }}
          </p>
        </div>
      </div>
    </div>
    <UiKitIcon v-if="typeQuery === 'icon'" />
    <UiKitBrands
      v-if="typeQuery === 'brands-config'"
      :testConfigDataBrand="testConfigDataBrand"
    />
    <UiKitMain v-else />
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/style/main";

.ui-kit-view {
  width: 100vw;
  height: 100%;
  background-color: var(--color-bg-primary);
  margin-top: 150px;
  padding: 0 20px;

  @include render-themes;

  &__prev {
    margin-bottom: 15px;
  }
  &__links {
    cursor: pointer;
    padding: 15px;
    border-radius: 5px;
    background-color: var(--color-white);
    width: 250px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 15px;
    &-item {
      font-size: 20px;
      font-weight: bold;
      transition: all 0.4s;
      color: var(--color-tertiary);
      &:hover {
        color: var(--color-primary);
      }
    }
  }
  &__branding {
    &-tabs {
      display: flex;
      gap: 8px;
      &__item {
        cursor: pointer;
        padding: 15px;
        border-radius: 5px;
        transition: all 0.5s;
        &.--active {
          color: var(--color-primary);
          background-color: var(--color-grey-blue);
        }
      }
    }
  }
}
</style>
